module.exports = __webpack_public_path__ + "static/img/ewm.d11c9ea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ewm.png
// module id = 4+fO
// module chunks = 44